angular.module('gym.reports').controller('CopyReportToGymCtrl', ["$rootScope", "$scope", "$http", "Restangular", "$stateParams", "$modalInstance", "$timeout", "flash", "report", function($rootScope, $scope, $http, Restangular, $stateParams, $modalInstance, $timeout, flash, report) {
  var Subscribers, allSubscribers, gym;
  gym = $rootScope.gym;
  Subscribers = Restangular.all('gyms', $stateParams.gymId).all('subscribers');
  allSubscribers = Subscribers.getList({
    count: 1000
  }).$object;
  $scope.pageParams = {
    selectedGym: [],
    gymEmail: ''
  };
  $scope.getGyms = function(value) {
    if (!value) {
      return allSubscribers;
    }
    return Subscribers.getList({
      search: value
    }).then(function(gyms) {
      return gyms;
    });
  };
  $scope.selectGym = function(gym) {
    $scope.pageParams.selectedGym = [gym];
    return $timeout(function() {
      return document.getElementById('copyReportGymEmail').focus();
    }, 500);
  };
  $scope.removeGym = function() {
    return $scope.pageParams.selectedGym = [];
  };
  $scope.cancel = function() {
    return $modalInstance.dismiss('cancel');
  };
  $scope.isReady = function() {
    return $scope.pageParams.selectedGym.length && $scope.pageParams.gymEmail.trim();
  };
  return $scope.submit = function() {
    var params, url;
    $scope.isLoading = true;
    params = {
      target_gym_id: $scope.pageParams.selectedGym[0].id,
      target_gym_email: $scope.pageParams.gymEmail.trim()
    };
    url = `/gyms/${gym.id}/reports/${report.id}/copy_to_gym`;
    return $http.put(url, params).then(function() {
      flash.success = "Report copied successfully";
      return $modalInstance.close();
    }, function(response) {
      $scope.error = response.data.error;
      return $scope.isLoading = false;
    });
  };
}]);
